var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        value: _vm.showDialog,
        "overlay-color": "grey darken-2",
        persistent: "",
        "max-width": "720px",
        "content-class": "consent-banner",
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "accent pa-4 pr-0",
          class: { "pl-0": _vm.$vuetify.breakpoint.xsOnly },
        },
        [
          _c(
            "div",
            { staticClass: "consent-banner", staticStyle: { height: "300px" } },
            [
              _c("h3", [_vm._v("Consent for Data Collection and Processing")]),
              _c("p", [
                _vm._v(
                  " We value your privacy and want to ensure you understand how your personal data will be used. By providing your consent below, you agree to the collection and processing of your data for the purpose of enhancing our data analysis to improve the quality of our services. "
                ),
              ]),
              _c(
                "div",
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "" } },
                    [
                      _c(
                        "v-radio-group",
                        {
                          attrs: { column: "" },
                          model: {
                            value: _vm.agreeState,
                            callback: function ($$v) {
                              _vm.agreeState = $$v
                            },
                            expression: "agreeState",
                          },
                        },
                        [
                          _c("v-radio", {
                            attrs: { value: true },
                            scopedSlots: _vm._u([
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      [
                                        _vm._v(
                                          " I consent to the collection and processing of my data for enhancing data analysis, as described in "
                                        ),
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { bottom: "" },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "activator",
                                                fn: function ({ on }) {
                                                  return [
                                                    _c(
                                                      "a",
                                                      _vm._g(
                                                        {
                                                          attrs: {
                                                            target: "_blank",
                                                            href: "https://dealio.ai/privacy-policy/",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                            },
                                                          },
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _vm._v(
                                                          " Privacy Policy "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ]),
                                          },
                                          [_vm._v(" Click to read ")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          }),
                          _c("v-radio", {
                            attrs: {
                              label:
                                "I do not consent to the collection and processing of my data for enhancing data analysis.",
                              value: false,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: {
                    disabled: _vm.agreeState === null,
                    color: "primary",
                  },
                  on: { click: _vm.submissionHandler },
                },
                [_vm._v(" Confirm ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }